module.exports = __webpack_public_path__ + "static/media/Bita Blockchain-Logo.9062b2d3.png";